import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { updateEmail } from "../../../features/user/userSlice";
import { setUser, fetchUserById } from "../../../features/user/userSlice";
import { isEmail } from "../../../utils/validation";

export default function EmailChangeModal({ isOpen, onClose, idUser, vorname }) {
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const [waitingForVerification, setWaitingForVerification] = useState(false);

  useEffect(() => {
    if (!waitingForVerification) return;

    const interval = setInterval(() => {
      dispatch(fetchUserById(user.idUser)).then((res) => {
        if (res.payload?.isVerifiedEmail === 1) {
          dispatch(setUser(res.payload));
          clearInterval(interval);
          toast.success("E-Mail erfolgreich verifiziert");
          setWaitingForVerification(false);
          onClose();
        }
      });
    }, 3000);

    return () => clearInterval(interval);
  }, [waitingForVerification]);

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async () => {
    if (!isEmail(email)) {
      toast.error("Bitte geben Sie eine gültige Email-Adresse ein.");
      return;
    }
    setLoading(true);
    dispatch(
      updateEmail({
        id: idUser,
        email: email,
        vorname: vorname,
      }),
    )
      .unwrap()
      .then((res) => {
        toast.success("E-Mail erfolgreich geändert");
        dispatch(setUser({ ...res.updatedUser })); // Redux aktualisieren
        localStorage.setItem("user", JSON.stringify(res.updatedUser)); // lokal speichern
        setEmail(res.updatedUser.email);
        setWaitingForVerification(true);
      })
      .catch((err) => {
        toast.error(err.message || "Fehler beim Ändern der Email");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
        <div className="bg-white p-6 rounded-xl shadow-md w-full max-w-md">
          <h2 className="kn-h3 mb-4">Email ändern</h2>

          <div className="flex flex-col gap-4">
            <input
              type="email"
              name="email"
              placeholder="Neue Email"
              className="inputStyle"
              value={email}
              onChange={handleChange}
            />

            {waitingForVerification && (
              <p className="text-sm text-knapp-accent">
                Bitte überprüfen Sie Ihre E-Mail-Adresse und bestätigen Sie den
                Link.
              </p>
            )}
          </div>

          <div className="flex justify-end gap-3 mt-6">
            <button onClick={onClose} className="kn-btn-ghost">
              Abbrechen
            </button>
            <button
              onClick={handleSubmit}
              disabled={loading}
              className="kn-btn-primary"
            >
              {loading ? "Speichern..." : "Speichern"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
